import {Page} from "../page";

export const contact: Page = {
    uri: 'contact',
    icon: '📧',
    title: $localize`:@@page-contact-title:Contact`,
    summary: $localize`:@@page-contact-summary:Contact us for any questions or feedback.`,
    markdownContent: $localize`:@@page-contact-markdown-content:
You can find us at several places on the internet. If you have any questions or feedback, feel free to reach out to us.

### Email

You can contact us at [app@ludoya.com](mailto:app@ludoya.com).

### Social Media

Follow us on [X](https://www.x.com/ludoyapp).

### Messaging

If you have any questions or feedback, you can find us on [Discord](https://discord.gg/QG2yNYypVn).
You can also reach out to us via [Telegram](https://t.me/ludoyapp).
        `,
}
